<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
import type { FormCheckboxGroupInput } from '~/composables/useForm'

const props = defineProps<{
  data: FormCheckboxGroupInput
}>()

const { t } = useI18n()
const { dt } = useDirectusTranslation()

const validation = computed(() => {
  return [
    props.data.required ? 'required' : null,
  ].join('|')
})

const options = computed(() => {
  return props.data.options.map((option) => {
    return {
      value: option.form_checkbox_group_input_item_id.value,
      label: dt(option.form_checkbox_group_input_item_id.translations)?.text ?? '',
    }
  })
})
</script>

<template>
<FormKitLazyProvider config-file="true">

  <div>
    <FormKit
      :id="props.data.key"
      type="checkbox"
      :options="options"
      :name="props.data.key"
      :label="dt(props.data.translations)?.label"
      :validation="validation"
      :classes="{
        options: 'flex gap-.8rem flex-wrap my-1rem',
        inner: 'hidden',
      }"
      :validation-messages="{
        required: t('form.validation.generic_choice'),
      }"
    >
      <template #label="context">
        <span
          class="inline-block cursor-pointer select-none bg-starline-secondary px-1.6rem py-.8rem text-1.3rem text-neutral-white tracking-[.4rem] uppercase ring-px transition duration-300ms signature-page:bg-signature-black focus-within:outline hover:ring-starline-primary hover:signature-page:ring-signature"
          :class="context.value?.includes(context.option.value as unknown as string) ? 'shadow-starline signature-page:shadow-signature !ring-3px !ring-starline-primary signature-page:!ring-signature relative' : 'shadow-none ring-neutral-darkGray signature-page:ring-signature/14'"
        >{{ context.option.label }}</span>
      </template>
    </FormKit>
  </div>

</FormKitLazyProvider>
</template>

<style>

</style>
